import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from "../classNames.js";
export const Panel = ({ children, className, heading, ...props }) => {
    const _class = classNames("panel", className);
    return (_jsxs("nav", { className: _class, ...props, children: [heading && _jsx("p", { className: "panel-heading", children: heading }), children] }));
};
